import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';

import logo from '../images/404.png';
import * as actionsSession from '../actions/session.actions';

// eslint-disable-next-line
import style from './_styles.css';

class Index extends Component {
    UNSAFE_componentWillMount() {
        if (sessionStorage.valid) {
            this.props.logOutUser();
        }
    }

    handleClick = (event) => {
        this.props.history.push('/');
    };

    render() {
        return (
            <div className="fullscreen center bg_dark_grey_blue logout">
                <div className="fullWidth">
                    <div className={'numberLogout'}>
                        <CardMedia className={'imgLogout'} image={logo} title="iFlares" />
                    </div>
                    <h3 className="barlowsemicondensed_bold c_white uppercase">
                        <FormattedMessage id="thank_for_use_it" />
                    </h3>
                    <Button onClick={this.handleClick} className={'root-link'}>
                        <span className={'pLogout'}>
                            <FormattedMessage id="login_back" />
                        </span>
                    </Button>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsSession), dispatch);
};

Index = connect(null, mapDispatchToProps)(Index);

Index = withRouter(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/pages/Logout.js